export const mimeTypes: Record<string, string> = {
  "text/csv": "XLS",
  "text/plain": "TXT",
  "image/gif": "IMG",
  "image/jpeg": "IMG",
  "image/png": "IMG",
  "application/pdf": "PDF",
  "application/msword": "DOC",
  "application/vnd.ms-excel": "XLS",
  "application/vnd.ms-powerpoint": "PPT",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "DOC",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": "PPT",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLS",
  "application/vnd.oasis.opendocument.presentation": "PPT",
  "application/vnd.oasis.opendocument.spreadsheet": "XLS",
  "application/vnd.oasis.opendocument.text": "TXT",
};

export const mimeTypesExcLImg: Record<string, string> = {
  "text/csv": "XLS",
  "text/plain": "TXT",
  "application/pdf": "PDF",
  "application/msword": "DOC",
  "application/vnd.ms-excel": "XLS",
  "application/vnd.ms-powerpoint": "PPT",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "DOC",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": "PPT",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLS",
  "application/vnd.oasis.opendocument.presentation": "PPT",
  "application/vnd.oasis.opendocument.spreadsheet": "XLS",
  "application/vnd.oasis.opendocument.text": "TXT",
};

export const XLSmimeTypes: Record<string, string> = {
  "application/vnd.ms-excel": "XLS",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLS",
  "application/vnd.oasis.opendocument.spreadsheet": "XLS",
};

const asArray = Object.entries(mimeTypes);

export const getMimeExtension = (mime: string): string =>
  (asArray.find(([key]) => key === mime) || "")[1] || "?";
